// Global Constants
import { RESET_STATE } from 'services/auth/constants';
// @ts-ignore
import { SET_CURRENT_ORGANIZATION_ID } from 'services/currentOrganizationId/constants';
// @ts-ignore
import { SET_CURRENT_SEASON_ID } from 'services/currentSeasonId/constants';
// @ts-ignore
import { SET_CURRENT_ENTITY_ID } from 'services/currentEntityId/constants';

// The initial state of the App
const initialState = {};

function initialDataLoadedReducer(state: any = initialState, action: any): any {
    const { type } = action;
    if (type === RESET_STATE) return initialState;

    if (type === SET_CURRENT_ORGANIZATION_ID) {
        return {
            ORGANIZATIONS_LOAD: state.ORGANIZATIONS_LOAD,
            USERS_ME_LOAD: state.USERS_ME_LOAD
        };
    }

    if (type === SET_CURRENT_SEASON_ID) {
        return {
            ORGANIZATIONS_LOAD: state.ORGANIZATIONS_LOAD,
            USERS_ME_LOAD: state.USERS_ME_LOAD
        };
    }

    if (type === SET_CURRENT_ENTITY_ID) {
        return {
            ...state,
            HARVEST_EVENTS_LOAD: false
        };
    }

    const matches = /(.*)_(SUCCEEDED)/.exec(type);

    // not a *_REQUEST / *_SUCCEEDED /  *_FAILURE actions, so we ignore them
    if (!matches) return state;

    const [, requestName, requestState] = matches;
    return {
        ...state,
        // Store whether a request is happening at the moment or not
        [requestName]: requestState === 'SUCCEEDED'
    };
}

export default initialDataLoadedReducer;
